<template>
  <div class="card-modules" :key="index" v-for="(moduleItem, index) in data">
    <h5 class="title-modules">{{ moduleItem.moduleName }}</h5>
    <template v-if="moduleItem.moduleName !== '验收标准'">
      <div
        :class="fieldItem.fieldTypeId == 2 ? 'line' : ''"
        :key="key"
        v-for="(fieldItem, key) in moduleItem.fields"
      >
        <card-field-table
          :fieldData="fieldItem"
          v-if="fieldItem.fieldTypeId == 2"
        ></card-field-table>
        <card-field-pic
          :list="JSON.parse(fieldItem.fieldValue)"
          v-else-if="fieldItem.fieldTypeId == 4"
        ></card-field-pic>
        <card-field-input v-else :fieldData="fieldItem"></card-field-input>
      </div>
    </template>
    <template v-if="moduleItem.moduleName == '验收标准'">
      <card-check-standard :data="standardData"></card-check-standard>
    </template>
  </div>
</template>

<script>
import CardFieldInput from "@/components/QualityStandard/components/CardFieldInput.vue";
import CardFieldTable from "@/components/QualityStandard/components/CardFieldTable.vue";
import CardFieldPic from "@/components/QualityStandard/components/CardFieldPic.vue";
import CardCheckStandard from "@/components/QualityStandard/CardCheckStandard.vue";
export default {
  name: "CardModules",
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    standardData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    CardFieldInput,
    CardFieldTable,
    CardFieldPic,
    CardCheckStandard
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="less">
.card-modules {
  margin-top: 10px;
  background: white;
  padding: 0 0px 10px 15px;
  box-shadow: 0 2px 3px #0000152b;
}
.title-modules {
  padding: 15px 0 15px 0px;
  font-size: 16px;
  border-bottom: 1px solid #dcdcdc;
}
.line {
  border-top: 1px solid #dcdcdc;
}
</style>
